export const getPageHash = () => {
  return window && window.location.hash && window.location.hash != ''
    ? window.location.hash.split('#')[1]
    : null;
};

export const getPageUrlWithoutQueryAndHash = () => {
  return window ? window.location.pathname : null;
};
